
/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';

import axios from '../../../utils/axios';
import { dispatch } from '../../index';
import { handleError, handleSuccess } from '../../../utils/apiResponseHandler.js';

const initialState = {
    error: null,
    agentTemplates: null,
    singleAgentTemplate: null,
    loading: false,
    saveLoading: false,
    totalPages: null,
    totalCount: null,
};

const slice = createSlice({
    name: 'adminAgentTemplate',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        isLoading(state, action) {
            state.loading = action.payload;
        },

        isSaveLoading(state, action) {
            state.saveLoading = action.payload;
        },

        setAgentTemplateDataSuccess(state, action) {
            state.agentTemplates = action.payload?.data;
            state.totalCount = action.payload?.totalCount;
            state.totalPages = action.payload?.totalPages;
        },

        setSingleAgentTemplateDataSuccess(state, action) {
            state.singleAgentTemplate = action.payload;
        },

        updateAgentTemplateDataSuccess(state, action) {
            const index = state.agentTemplates.findIndex(agentTemplate => agentTemplate._id === action.payload.id);
            const agentTemplateData = state.agentTemplates[index];
            const newData = { ...agentTemplateData, ...action.payload.data };
            state.agentTemplates[index] = newData
        },

        createAgentTemplateDataSuccess(state, action) {
            state.agentTemplates.push(action.payload);
        },

        deleteAgentTemplateDataSuccess(state, action) {
            const newAgentTemplates = state.agentTemplates.filter(agentTemplate => agentTemplate._id !== action.payload.id);
            state.agentTemplates = newAgentTemplates;
        },

    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getAllAgentTemplates({ page, limit, search }) {
    return async () => {
        try {
            dispatch(slice.actions.isLoading(true))

            const response = await axios.get(`/admin/agent-template?search=${search}&page=${page}&limit=${limit}`);
            dispatch(slice.actions.setAgentTemplateDataSuccess(response?.data))

            return response?.data?.data;
        }
        catch (err) {
            handleError(err, dispatch);
        }
        finally {
            dispatch(slice.actions.isLoading(false))
        }
    }
}
export function getSingleAgentTemplate({ id }) {
    return async () => {
        try {
            dispatch(slice.actions.isLoading(true))

            const response = await axios.get(`/admin/agent-template/${id}`);
            dispatch(slice.actions.setSingleAgentTemplateDataSuccess(response?.data))

            return response?.data?.data;
        }
        catch (err) {
            handleError(err, dispatch);
        }
        finally {
            dispatch(slice.actions.isLoading(false))
        }
    }
}

export function createAgentTemplate(data) {
    return async () => {
        try {
            dispatch(slice.actions.isSaveLoading(true))

            const response = await axios.post(`/admin/agent-template`, data);
            dispatch(slice.actions.createAgentTemplateDataSuccess(response.data))

            handleSuccess(response, "Agent Template created successfully", dispatch);

            return response.data;
        }
        catch (err) {
            handleError(err, dispatch);
            throw err
        }
        finally {
            dispatch(slice.actions.isSaveLoading(false))
        }
    }
}

export function updateAgentTemplate(id, data) {
    return async () => {
        try {
            dispatch(slice.actions.isSaveLoading(true))

            const response = await axios.put(`/admin/agent-template/${id}`, data);

            dispatch(slice.actions.updateAgentTemplateDataSuccess(
                { data, id }
            ))
            handleSuccess(response, "Agent Template updated successfully", dispatch);

            return response.data;
        }
        catch (err) {
            handleError(err, dispatch);
            throw err
        }
        finally {
            dispatch(slice.actions.isSaveLoading(false))
        }
    }
}

export function deleteAgentTemplate(id) {
    return async () => {
        try {
            const response = await axios.delete(`/admin/agent-template/${id}`);
            dispatch(slice.actions.deleteAgentTemplateDataSuccess(
                { id }
            ))
            handleSuccess(response, "Agent Template deleted successfully", dispatch);

            return response.data?.message;
        }
        catch (err) {
            handleError(err, dispatch);
            throw err
        }
    }
}
